import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";

/**Componente que muestra el nombre del usuario actual */
export interface Props {
    usuario?: models.Session | null;
    onCerrarSesion?: () => void;
}

class UsuarioRowNoRx extends React.PureComponent<Props> {
    render() {
        const props = this.props;
        const usuario = props.usuario;
        return (
            usuario ?
                <span>
                    <b>Usuario actual:</b> {usuario.Nombre}
                    <kea.Link onClick={this.props.onCerrarSesion} >
                        Cerrar sesión
                    </kea.Link  >
                </span>
                :
                null
        )
    }
}

const UsuarioRowRx = componentToRx(UsuarioRowNoRx);
export const UsuarioRow = (props: Props) => <UsuarioRowRx usuario={resources.User.SessionRx} {...props} />;


// WEBPACK FOOTER //
// ./app/features/general/login/usuariorow.tsx